"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.AddressBookComponent = void 0;
var angular = require("angular");
var verifier_1 = require("./verifier");
require('./address-book.component.css');
var COMPONENT_NAME = 'smartorg.r6.mgmts.addressBook2';
var userTemplate = {
    _id: '',
    username: '',
    password: '',
    firstname: '',
    lastname: '',
    email: '',
    phone: {
        main: '',
        ext: ''
    },
    organisation: '',
    groupname: '',
    groups: [],
    enforcePassword: false,
    resetToFirstLogin: true
};
function hardcopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
var AddressBookComponent = /** @class */ (function () {
    function AddressBookComponent($scope, $timeout) {
        this.$timeout = $timeout;
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        this.backToMain = function () {
            $scope.$emit('workbench:back');
        };
        this.postSetPassword = function (status) {
            $('#passwordModal').modal('hide');
            $scope.$broadcast('password:save_feedback', { status: status });
        };
    }
    AddressBookComponent.prototype.$onInit = function () {
        this.refresh();
    };
    AddressBookComponent.prototype.showError = function (code, message) {
        this.showAlert('danger', "Server Error " + code, message);
    };
    AddressBookComponent.prototype.showSuccess = function (title, message) {
        this.showAlert('success', title, message);
    };
    AddressBookComponent.prototype.selectUser = function (inUser) {
        if (inUser && inUser._id && this.listOfGroups) {
            var userId_1 = inUser._id;
            inUser.groups = this.listOfGroups.filter(function (g) {
                return g.users.find(function (u) { return u === userId_1; });
            }).map(function (g) { return g.groupname; }).sort(function (a, b) { return a.toLowerCase() < b.toLowerCase() ? -1 : 1; });
            inUser.groupname = inUser.groups.join(', ');
        }
        this.selectedUser = __assign(__assign({}, userTemplate), (inUser || {}));
        this.selectedUserOriginal = hardcopy(this.selectedUser);
        this.verifier = new verifier_1.Verifier(this.listOfUsers, this.selectedUser);
        this.checkDirty();
    };
    AddressBookComponent.prototype.reset = function () {
        var _this = this;
        var selectedUser = this.listOfUsers.find(function (u) { return u._id === _this.selectedUserOriginal._id; });
        this.selectUser(selectedUser);
    };
    AddressBookComponent.prototype.addUser = function () {
        var user = {
            enforcePassword: false,
            resetToFirstLogin: true
        };
        this.selectUser(user);
        angular.element('#usernameInput').focus();
    };
    AddressBookComponent.prototype.deleteUser = function () {
        var ctrl = this;
        bootbox.dialog({
            message: 'Delete user <b>' + ctrl.selectedUser.username + '?</b>',
            title: 'Confirm Deletion',
            buttons: {
                confirm: {
                    label: 'Delete',
                    className: 'btn-danger',
                    callback: function () { return ctrl.deleteSelectedUser(); }
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-primary'
                }
            }
        });
    };
    AddressBookComponent.prototype.refresh = function () {
        this.getData(this.selectedUser ? this.selectedUser.username : null);
    };
    AddressBookComponent.prototype.save = function () {
        if (!this.verifier || !this.verifier.allValid()) {
            return;
        }
        if (this.selectedUser._id) {
            this.saveSelectedUser();
        }
        else {
            this.saveNewUser();
        }
    };
    AddressBookComponent.prototype.checkDirty = function () {
        this.hasChanges = JSON.stringify(this.selectedUserOriginal) !== JSON.stringify(this.selectedUser);
        this.allValid = this.verifier && this.verifier.allValid();
    };
    /**
     * Generate a complex random password if user did not
     * enter any password.
     *
     * @returns {string} Password string with 4 of each
     *     type of charactors.
     */
    AddressBookComponent.prototype.generateRandomPassword = function () {
        var lowChar = 'abcdefghijklmnopqrstuvwxyz';
        var upChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var number = '0123456789';
        var special = '~!@#$%^&*()_+`-=[]{};:<>?,./\\|';
        var getRandomChar = function (input) {
            return input.charAt(Math.floor(Math.random() * input.length));
        };
        var pass = [];
        for (var i = 0; i < 4; i++) {
            pass.push(getRandomChar(lowChar));
            pass.push(getRandomChar(upChar));
            pass.push(getRandomChar(number));
            pass.push(getRandomChar(special));
        }
        return pass.sort(function () { return 0.5 - Math.random(); }).join('');
    };
    AddressBookComponent.prototype.transformDbUser = function (user) {
        var _id = user._id, username = user.username, name = user.name, email = user.email, phone = user.phone, organisation = user.organisation, isFirstLogin = user.isFirstLogin, admin = user.admin;
        var nn = (name ? name.split(',') : []).map(function (x) { return x.trim(); });
        var _a = nn && nn.length === 2 ? nn : ['', ''], lastname = _a[0], firstname = _a[1];
        var p = phone ? phone.split(',') : [];
        var _b = p && p.length === 2 ? p : ['', ''], main = _b[0], ext = _b[1];
        var enforcePassword = admin && admin.force_password_change && true;
        var resetToFirstLogin = isFirstLogin || false;
        return {
            _id: _id,
            username: username,
            firstname: firstname,
            lastname: lastname,
            email: email,
            phone: { main: main, ext: ext },
            organisation: organisation,
            enforcePassword: enforcePassword,
            resetToFirstLogin: resetToFirstLogin
        };
    };
    // API calls
    AddressBookComponent.prototype.getData = function (initSelectedUsername) {
        var _this = this;
        return Promise.all([
            this.smartorgApi.getListOfUsers(),
            this.smartorgApi.getListOfGroups()
        ]).then(function (_a) {
            var users = _a[0], groups = _a[1];
            var sortedUsers = users.sort(function (_a, _b) {
                var a = _a.username;
                var b = _b.username;
                return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
            });
            _this.listOfUsers = sortedUsers.map(function (dbUser) { return _this.transformDbUser(dbUser); });
            var tmpGroups = groups.map(function (g) { return (__assign({ display: g.groupname }, g)); });
            _this.listOfGroups = __spreadArray([{ groupname: '', display: '-- Select Group --', users: [] }], tmpGroups, true);
            if (initSelectedUsername) {
                var selectedUser = _this.listOfUsers.find(function (u) { return u.username === initSelectedUsername; });
                _this.selectUser(selectedUser);
            }
            else {
                _this.selectUser(null);
            }
            _this.$timeout();
        })["catch"](function (err) {
            _this.showError(err.status, 'Failed to get list of users. ' + err.message);
        });
    };
    AddressBookComponent.prototype.saveNewUser = function () {
        var _this = this;
        var userSpecPassword = this.selectedUser.password && 1;
        if (!userSpecPassword) {
            this.selectedUser.password = this.generateRandomPassword();
        }
        var _a = this.selectedUser, username = _a.username, lastname = _a.lastname, firstname = _a.firstname, password = _a.password, email = _a.email, _b = _a.phone, phoneMain = _b.main, phoneExt = _b.ext, organisation = _a.organisation, groupname = _a.groupname;
        return this.smartorgApi.newUser(username, lastname + ", " + firstname, password, email, phoneMain + "," + phoneExt, organisation, groupname).then(function (userId) {
            if (!userSpecPassword) {
                var title = "<div>New user " + username + " created. <br>" +
                    'Here is system generated password, please save it.</div>';
                bootbox.prompt({
                    title: title,
                    value: password, callback: function () {
                    }
                });
            }
            else {
                _this.showSuccess('Success!', "New user " + username + " created with preset password!");
            }
            _this.saveAdminSettings(userId);
        })["catch"](function (err) {
            _this.showError(err.status, "Failed to create " + username + ". " + err.message);
        });
    };
    AddressBookComponent.prototype.saveSelectedUser = function () {
        var _this = this;
        var _a = this.selectedUser, userId = _a._id, username = _a.username, lastname = _a.lastname, firstname = _a.firstname, email = _a.email, _b = _a.phone, phoneMain = _b.main, phoneExt = _b.ext, organisation = _a.organisation, groupname = _a.groupname;
        return this.smartorgApi.modifyExistingUser(userId, username, lastname + ", " + firstname, email, phoneMain + "," + phoneExt, organisation, groupname).then(function () {
            _this.showSuccess('Success!', "Saved changes to user " + username + " successfully!");
            _this.saveAdminSettings(userId);
        })["catch"](function (err) {
            _this.showError(err.status, "Failed to save changes to user " + username + ". " + err.message);
        });
    };
    AddressBookComponent.prototype.saveAdminSettings = function (userId) {
        var _this = this;
        var _a = this.selectedUser, username = _a.username, enforcePassword = _a.enforcePassword, resetToFirstLogin = _a.resetToFirstLogin;
        return this.smartorgApi.updateUserAdminSettings(userId, {
            passwordChange: enforcePassword || false,
            resetToFirstLogin: resetToFirstLogin || false
        }).then(function () {
            _this.getData(username);
        })["catch"](function (err) {
            _this.showError(err.status, "Failed to save user admin settings. " + err.message);
        });
    };
    AddressBookComponent.prototype.deleteSelectedUser = function () {
        var _this = this;
        var _a = this.selectedUser, userId = _a._id, username = _a.username;
        return this.smartorgApi.deleteUser(userId).then(function () {
            _this.listOfUsers = _this.listOfUsers.filter(function (user) { return user._id !== userId; });
            _this.selectUser(null);
            _this.showSuccess('Success!', "User " + username + " is deleted!");
        })["catch"](function (err) {
            _this.showError(err.status, "Failed to delete user " + username + ". " + err.message);
        });
    };
    AddressBookComponent.prototype.setPassword = function (oldPassword, newPassword) {
        var _this = this;
        if (this.selectedUser && this.selectedUser._id) {
            var username_1 = this.selectedUser.username;
            return this.smartorgApi.adminSetPassword(username_1, newPassword).then(function () {
                _this.showSuccess('Success!', "Password for " + username_1 + " is set!");
                _this.postSetPassword(0);
            })["catch"](function (err) {
                _this.showError(err.status, "Set password for " + username_1 + " failed!");
                _this.postSetPassword(1);
            });
        }
        else {
            this.selectedUser.password = newPassword;
            this.postSetPassword(0);
            this.checkDirty();
            return null;
        }
    };
    return AddressBookComponent;
}());
exports.AddressBookComponent = AddressBookComponent;
angular.module(COMPONENT_NAME, []).component('addressBook', {
    template: require('./address-book.component.html'),
    bindings: {
        smartorgApi: '='
    },
    controller: AddressBookComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=address-book.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/address-book2/address-book.component.js